import React from 'react';
import './CommonStrip.scss';
import PropTypes from 'prop-types';

const CommonStrip = (props = {}) => {
    const { StripIcon, StripInformation } = props;

    return (
        <div className="strip_background_channel">
            <p>
                {/* <i>{StripIcon} </i> */}
                <span>{StripInformation}</span>
                <i>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path
                            d="M3.3335 12.6668L12.6668 3.3335"
                            stroke="#0D1116"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                        <path
                            d="M12.6668 12.6668L3.3335 3.3335"
                            stroke="#0D1116"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                </i>
            </p>
        </div>
    );
};
CommonStrip.propTypes = {
    StripIcon: PropTypes.node,
    StripInformation: PropTypes.string.isRequired,
};

export default React.memo(CommonStrip);
